// Custom inline SVG logo - a "BA" wordmark merged with a single data point.
// Geometric, monochrome with one accent dot, uses currentColor for theming.

type Props = {
  size?: number;
  className?: string;
  showWordmark?: boolean;
};

export function LogoMark({ size = 32, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="ABA Chapter 1 logo"
      role="img"
    >
      {/* outer rounded square */}
      <rect x="0.75" y="0.75" width="30.5" height="30.5" rx="6"
        stroke="currentColor" strokeOpacity="0.18" strokeWidth="1.5" />
      {/* stylized "B-A" - bars representing rate-of-response graph */}
      <path d="M6 22 L6 10 L11 10 L11 17 L16 17 L16 10 L21 10 L21 22 L16 22 L16 21 L11 21 L11 22 Z"
        fill="currentColor" />
      {/* accent dot - a data point */}
      <circle cx="25" cy="22" r="2" fill="hsl(var(--primary))" />
    </svg>
  );
}

export function LogoLockup({ className }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2.5 ${className ?? ""}`}>
      <LogoMark size={28} />
      <div className="hidden sm:flex flex-col leading-none">
        <span className="text-[13px] font-semibold tracking-tight">ABA Study</span>
        <span className="text-[10.5px] font-medium text-muted-foreground tracking-[0.12em] uppercase">
          Chapter 01
        </span>
      </div>
    </div>
  );
}
